import { tv } from "../../variants/tv.js";
const reviewScoreEmphasisVariants = {
    regular: {
        verbiageSlot: 'text-neutral-13',
        reviewTextSlot: 'text-neutral-13',
        separatorSlot: 'text-neutral-13',
        dataSlot: 'text-neutral-13'
    },
    bold: {
        verbiageSlot: 'text-neutral-1',
        reviewTextSlot: 'text-neutral-1',
        separatorSlot: 'text-neutral-1',
        dataSlot: 'text-neutral-1'
    }
};
const reviewScoreEmphases = Object.keys(reviewScoreEmphasisVariants);
const reviewScoreVariants = tv({
    slots: {
        rootSlot: 'inline-flex items-center',
        badgeSlot: 'shrink-0',
        contentSlot: 'flex flex-col items-start justify-center',
        verbiageSlot: 'text-body3 font-bold',
        reviewLineSlot: 'flex items-center gap-1 text-body3 font-medium',
        reviewTextSlot: 'shrink-0 whitespace-nowrap',
        separatorSlot: 'shrink-0',
        dataSlot: ''
    },
    variants: {
        emphasis: reviewScoreEmphasisVariants,
        size: {
            xs: {
                rootSlot: 'gap-1',
                verbiageSlot: 'hidden'
            },
            sm: {
                rootSlot: 'gap-2'
            },
            md: {
                rootSlot: 'gap-2'
            },
            lg: {
                rootSlot: 'gap-2'
            },
            responsive: {
                rootSlot: 'gap-2',
                reviewLineSlot: '@2xs:text-body2'
            }
        },
        truncateData: {
            true: {
                rootSlot: 'max-w-full',
                contentSlot: 'min-w-0',
                reviewLineSlot: 'w-full min-w-0 overflow-hidden',
                dataSlot: 'min-w-0 truncate'
            }
        },
        doubleLineReview: {
            true: {},
            false: {
                verbiageSlot: 'text-body1'
            }
        }
    },
    defaultVariants: {
        emphasis: 'regular',
        size: 'md'
    }
});
const reviewScoreSizes = Object.keys(reviewScoreVariants.variants.size);
export { reviewScoreEmphases, reviewScoreEmphasisVariants, reviewScoreSizes, reviewScoreVariants };
